module.exports = __webpack_public_path__ + "static/media/Exit.7ab9c9da.svg";